import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import {
  Button,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";

import toast from "react-hot-toast";
import Select from "react-select";
import ServiceModule from "../../../services/KangarooServices/ServiceModule";
import WidgetService from "../../../services/KangarooServices/Intelligence/WidgetService";
import ServiceIntellWidgets from "../../../services/KangarooServices/Intelligence/ServiceIntellWidgets";

const ServiceWidgetForm = ({ isOpen, toggle, selectedItem, fetchData }) => {
  const [serviceData, setServiceData] = useState([]);
  const [widgetData, setWidgetData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchWidgetData = async () => {
    try {
      const response = await WidgetService.getList();
      setWidgetData(response);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchServiceData = async () => {
    setLoading(true);
    try {
      const response = await ServiceModule.getList();
      setServiceData(response);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWidgetData();
    fetchServiceData();
  }, []);

  const formik = useFormik({
    initialValues: {
      servicesIds: Array.isArray(selectedItem?.servicesIds)
        ? selectedItem.servicesIds.map(String)
        : [],
      widgetIds: Array.isArray(selectedItem?.widgetIds)
        ? selectedItem.widgetIds.map(String)
        : [],
    },
    enableReinitialize: true,
    onSubmit: async (values, { resetForm }) => {
      try {
        console.log("Submitting payload:", values);
        console.log("Selected item ID:", selectedItem?.id);
        
        if (selectedItem?.id) {
          await ServiceIntellWidgets.update(selectedItem.id, values);
          toast.success("Service-Widget updated successfully");
        } else {
          await ServiceIntellWidgets.create(values);
          toast.success("Service-Widget created successfully");
        }
        resetForm();
        fetchData();
        toggle();
      } catch (error) {
        console.log(error);
        toast.error("Something went wrong!");
      }
    },
  });

  const serviceOptions = serviceData.map((service) => ({
    value: String(service.id),
    label: service.name,
  }));

  const widgetOptions = widgetData?.map((widget) => ({
    value: String(widget.id),
    label: widget.name,
  }));

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        {selectedItem?.id ? "Edit Service-Widget Mapping" : "Create Service-Widget "}
      </ModalHeader>
      <ModalBody>
        <form onSubmit={formik.handleSubmit}>
          <div className="mb-3">
            <Label>Widget</Label>
            <Select
              isMulti
              options={widgetOptions}
              value={widgetOptions.filter((opt) =>
                formik.values.widgetIds.includes(opt.value)
              )}
              onChange={(selected) =>
                formik.setFieldValue(
                  "widgetIds",
                  selected ? selected.map((s) => s.value) : []
                )
              }
              placeholder="Select widget"
            />
          </div>

          <div className="mb-3">
            <Label>Services</Label>
            <Select
              isMulti
              options={serviceOptions}
              value={serviceOptions.filter((opt) =>
                formik.values.servicesIds.includes(opt.value)
              )}
              onChange={(selected) =>
                formik.setFieldValue(
                  "servicesIds",
                  selected ? selected.map((s) => s.value) : []
                )
              }
              placeholder="Select services"
              isLoading={loading}
            />
          </div>

          <div className="d-flex justify-content-end gap-3 mb-3">
            <button type="submit" className="btn btn-success">
              {selectedItem?.id ? "Update" : "Create"}
            </button>
            <button type="button" className="btn btn-danger" onClick={toggle}>
              Cancel
            </button>
          </div>
        </form>
      </ModalBody>
    </Modal>
  );
};

export default ServiceWidgetForm;